import { render } from "./UiSortMenuBadge.vue?vue&type=template&id=42ab7852&ts=true"
import script from "./UiSortMenuBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiSortMenuBadge.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiSortMenuBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "42ab7852"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('42ab7852', __exports__)) {
    api.reload('42ab7852', __exports__)
  }
  
  module.hot.accept("./UiSortMenuBadge.vue?vue&type=template&id=42ab7852&ts=true", () => {
    api.rerender('42ab7852', render)
  })

}


export default __exports__